<template>
  <img :src="proxyValue" @error="handleError" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: false,
      default: () => null
    },
    fallback: {
      type: String,
      required: false,
      default: () => '/img/emptyResort.png'
    }
  },
  data () {
    return {
      proxyValue: this.src
    }
  },
  methods: {
    handleError () {
      this.proxyValue = this.fallback
    }
  }
}
</script>